<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"

  import { type WithElementRef, cn } from "@/utils"

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithElementRef<HTMLAttributes<HTMLDivElement>> = $props()
</script>

<div
  bind:this={ref}
  data-slot="sheet-header"
  class={cn("flex flex-col gap-1.5 p-4", className)}
  {...restProps}
>
  {@render children?.()}
</div>
